<template>
  <div class="app-content-wrapper">
    <div class="table-wrapper">
      <custom-table ref="table"
                    :table-set="tableCondition"
                    :service-function="queryList"
                    router-name="/report/refuse-rate/view"
                    :isPaginationDisplay="false">
      </custom-table>
    </div>
  </div>
</template>
<script>
import { ShowSuccessMessage, ShowWarningMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import { initExhibitionTable } from '@/utils/tools/constant';
import ReportService from '@/views/report/api/report';

export default {
  components: {
    CustomTable,
  },
  data() {
    return {
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.tableCommon.cardType' },
          key: 'cardType',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.successfulCount' },
          key: 'successTradedTotal',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.successfulAmount' },
          key: 'successTradedAmount',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refuseCount' },
          key: 'repudiateTradedTotal',
          type: 'text',
          textFunc: (row) => (Number.isNaN(row.repudiateTradedTotal) ? 0 : Number(row.repudiateTradedTotal)),
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refuseAmount' },
          key: 'repudiateTradedAmount',
          type: 'text',
          textFunc: (row) => {
            if (row.repudiateTradedAmount) {
              return row.repudiateTradedAmount;
            }
            const { currency } = this.$route.query;
            if (currency === 'ALL' || !currency) {
              return 'USD 0';
            }
            return `${currency} 0`;
          },
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refuseRate' },
          key: 'repudiateRate',
          type: 'text',
          textFunc: (row) => `${row.repudiateRate === 'null' ? '0.00%' : `${(Number(row.repudiateRate) * 100).toFixed(2)}%`}`,
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.refundAmount' },
          key: 'refundAmount',
          type: 'text',
          textFunc: (row) => {
            if (row.refundAmount) {
              return row.refundAmount;
            }
            const { currency } = this.$route.query;
            if (currency === 'ALL' || !currency) {
              return 'USD 0';
            }
            return `${currency} 0`;
          },
        },
        {
          titleBar: { type: 'text', title: 'message.index.refundRate' },
          key: 'refundRate',
          type: 'text',
          textFunc: (row) => `${row.refundRate === 'null' ? '0.00%' : `${(Number(row.refundRate) * 100).toFixed(2)}%`}`,
        },
      ],
    };
  },
  methods: {
    async queryList(params) {
      try {
        const list = await ReportService.refuseRateRepotDetails(params);
        return Promise.resolve(initExhibitionTable(list, true));
      } catch (error) {
        return Promise.reject(error);
      }
    },
    onSearch() {
      if (!this.transactionMonth) {
        ShowWarningMessage(this.$t('message.validator.select', { select: this.$t('message.tableCommon.creationTime') }));
        return;
      }
      this.$refs.table.refreshTable();
    },
    async handleDownload() {
      if (!this.transactionMonth) {
        ShowWarningMessage(this.$t('message.validator.select', { select: this.$t('message.tableCommon.creationTime') }));
        return;
      }
      this.downloading = true;
      try {
        const params = {};
        const date = new Date(this.transactionMonth);
        params.month = date.getMonth() + 1;
        params.year = date.getFullYear();
        await ReportService.downloadReport(params);
        ShowSuccessMessage(this.$t('message.common.downloadTask'));
      } catch (err) {
        //
      }
      this.downloading = false;
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
</style>
